// extracted by mini-css-extract-plugin
export default {"images":"BinaryQuestion_images__PAH22","image":"BinaryQuestion_image__F5UEO","container":"BinaryQuestion_container__xljQx","text":"BinaryQuestion_text__-hD1F"};